<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {network, parameter} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import {decode, encode} from "../../../helpers";
    import PodokonnikMaterialList from "../../parts/PodokonnikMaterialList.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;


    let tkani = [
        'Калифорния барокко',
        'Прато перл',
        'Босфор',
        'Систра',
        'Базик',
        'Базило',
        'Валнут',
        'Луната В/О',
        'Маркизетт',
        'Палладо УНИ',
        'Силкшейд',
        'Базик БЛО',
        'Гоби',
        'Кара краш перламут колор В1',
        'Сето принт',
        'Флёр-рифлекс',
        'Аврора',
        'Базик Краш',
        'Глиттер',
        'Кара В1',
        'Латаро',
        'Мериса',
        'Тирари',
        'Алегро перл',
        'Бариси',
        'Капри',
        'Металлик',
        'Назар',
        'Кара перламут В1',
        'Лунд',
        'Металлик краш',
        'Миррор',
        'Навари',
        'Сето',
        'Сомнио перламут BLO',
        'Тенденс',
        'Невада',
        'Престо принт',
        'Систра BLO',
        'Блоссом',
        'Дим аут перламутр В1',
        'Онда',
        'Палладо перламут',
        'Краш перл',
        'Сето металлик',
        'Синус',
        'Базель',
        'Сето BLO',
        'Стайл',
        'Арабеска',
        'Базик УНИ',
        'Джайпур',
        'Порто перл',
        'Силкшейд АЛЮ',
        'Стайл перл'
    ];

    tkani = [...tkani].sort(); // создаём копию и сортируем её по алфавиту

    const cvetTkani = [
        '30970-белый (White)',
    ];


    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)
            let json = JSON.parse(decode(fetched.ind3))

            fetchData = await fetch();
            width.set(json.width)
            height.set(json.height)
            ind2 = json.ind2
            cvetKarniza = json.cvetKarniza
            system = json.system
            tipTkan2 = json.tipTkan
            cvetTkan2 = json.cvetTkan
            kursDollara = json.kursDollara
            components = json.components
            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    let components = {}

    const fetch = async () => {
        let result = await network.fetch_data('Жалюзи Плиссе', 'Плиссе');
        // let result = await network.fetch_data('Жалюзи Плиссе', 'Жалюзи Плиссе');


        let result2 = await network.fetch_data('Жалюзи Плиссе', tipTkan1);

        // Извлечение уникальных значений ind2 из result2
        let cvetTkani = [...new Set(result2.map(el => el.ind2))];

        cvetTkan1 = cvetTkani[0] ?? '';


        let result3
        let cvetTkani2 = []

        if (system == 'VS2 плиссе день/ночь') {
            if (tipTkan1 === tipTkan2) {
                result3 = result2
            } else {
                result3 = await network.fetch_data('Жалюзи Плиссе', tipTkan2);
            }
            cvetTkani2 = [...new Set(result3.map(el => el.ind2))];
            cvetTkan2 = cvetTkani2[0] ?? '';
        }

        /*  console.log('cvetTkan1:', cvetTkan1);
          console.log('cvetTkan2:', cvetTkan2);*/

        return {
            name: _.groupBy(result, 'name'),
            cvetTkani: cvetTkani,
            cvetTkani2: cvetTkani2,
            materials: result,
            price: result2,
            price2: result3,
            options,
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '1500'),

        cvetKarniza = 'Белый',
        system = 'VS2 плиссе',
        tipTkan2 = 'Аврора',
        cvetTkan2 = '',
        kursDollara = '84',
        tipTkan1 = 'Аврора',
        cvetTkan1 = '',
        // povish = 1,

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch(system);

    /* let
         montage_item,
         montage_price = 1;*/

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;
        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;

        let result = {
            type: 'Жалюзи Плиссе',
            name: 'Жалюзи Плиссе',
            subname: [
                $width + 'x' + $height, ', ', system, ', Цвет карниза - ', cvetKarniza,
                ', ткань - ' + tipTkan1 +
                ', цвет - ' + cvetTkan1,

                (system === 'VS2 плиссе день/ночь' ?
                    ', ткань - ' + tipTkan2 +
                    ', цвет - ' + cvetTkan2
                    :
                    '')

            ].join(''),
            title: 'Жалюзи Плиссе ' + [
                $width + 'x' + $height, ', ', system, ', Цвет карниза - ', cvetKarniza,
                ', ткань - ' + tipTkan1 +
                ', цвет - ' + cvetTkan1,
                (system === 'VS2 плиссе день/ночь' ?
                    ', ткань - ' + tipTkan2 +
                    ', цвет - ' + cvetTkan2
                    :
                    '')
            ].join(''),
            params: {
                ind1: [
                    system, ' ',
                ].join(''),
                ind2: system,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    tipTkan1,
                    cvetTkan1,
                    cvetKarniza,
                    system,
                    tipTkan2,
                    cvetTkan2,
                    kursDollara,
                    components,
                })),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 144
        };

        kursDollara = parseInt(data.result.find((item) => item.name === 'Курс доллара')?.sebestomost ?? 0);
        let arrWeight = data.arrWeight;
        let arrHeight = data.arrHeight;
        let title_addons = []


        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();
            let weightPrice = +item.ind4;
            let heightPrice = +item.ind5;


            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (components.hasOwnProperty(item.idTovar)) {
                let edIzmer = item.edIzmer.length ? item.edIzmer : 'шт.'

                kolvo = +components[item.idTovar]['count'];

                title_addons.push(`${item.name} - ${kolvo}/${edIzmer}`)
            }



            if (name.toLowerCase().includes('темно-серый') && cvetKarniza.toLowerCase() === 'темно-серый') {
                kolvo = 1;
            }

            if (name.toLowerCase().includes('коричневый') && cvetKarniza.toLowerCase() === 'коричневый') {
                kolvo = 1;
            }

            if (name.toLowerCase().includes('белый') && cvetKarniza.toLowerCase() === 'белый') {
                kolvo = 1;
            }

            // РАСЧЕТЫ УТОЧНИТЬ

            if (name.toLowerCase().includes('профиль вегас 15 мм')) {
                kolvo = (w / 1000 * 2 + 0.046).toFixed(2);
            }

            if (name.toLowerCase().includes('планка декор.(крышка профиля)')) {
                kolvo = (w / 1000 * 2 - 0.1).toFixed(2);
            }

            if (name.toLowerCase().includes('крепежная клейкая лента(блокирующая)')) {
                kolvo = (w / 1000 * 2 + 0.06).toFixed(2);
            }


            if (name.toLowerCase().includes('шнур 0,8 мм')) {
                kolvo = (h / 1000 * 8 - 0.4).toFixed(2);
            }

            if (name.toLowerCase().includes('башмак шнура 15 мм')) {
                kolvo = 4;
            }

            if (name.toLowerCase().includes('комплект защелок')) {
                kolvo = 4;
            }

            if (name.toLowerCase().includes('заглушка профиля 15 мм')) {
                kolvo = 4;
            }

            if (name.toLowerCase().includes('держатель(ручка)')) {
                kolvo = 4;
            }

            if (name.toLowerCase().includes('держатель - вкладыш (крепление ручки)')) {
                kolvo = 4;
            }

            if (name.toLowerCase().includes('промежуточная опора (опора шнура)')) {
                kolvo = 8;
            }

            if (name.toLowerCase().includes('пружина 4,5 см')) {
                kolvo = 4;
            }

            if (name.toLowerCase().includes('сборка (70) пл')) {
                kolvo = 1;
            }

            if (name.toLowerCase().includes('пл напил (10)+ткань(30)+подг(30)')) {
                kolvo = 1;
            }

            if (name.toLowerCase().includes('нарезка ткани (100)')) {
                kolvo = 1;
            }

            if (name.toLowerCase().includes('базик уни')) {
                kolvo = 1;
            }

            if (name.startsWith(system.toLowerCase())) {

                let resW = null;
                let resH = null;

                for (let i = 0; i < arrWeight.length; i++) {
                    if (w <= arrWeight[i]) {
                        resW = +arrWeight[i];
                        break;
                    }
                }

                for (let i = 0; i < arrHeight.length; i++) {
                    if (h <= arrHeight[i]) {
                        resH = +arrHeight[i];
                        break;
                    }
                }

                if (resW === weightPrice && resH === heightPrice) {
                    kolvo = 1;
                } else {
                    kolvo = 0;
                }

            }

            if (components.hasOwnProperty(item.idTovar)) {
                let edIzmer = item.edIzmer.length ? item.edIzmer : 'шт.'

                kolvo = +components[item.idTovar]['count'];

            }


            if (kolvo) {


                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * kursDollara * (+item.flag));
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * kursDollara * (+item.flag));
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost * kursDollara);

                // price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price * kursDollara * povish * (+item.flag));
                // price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price * kursDollara * povish * (+item.flag));
                // price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost * kursDollara);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price * kursDollara).toFixed(2),
                        opt: (+item.opt_price * kursDollara).toFixed(2),
                        sebest: (+item.sebestomost * kursDollara).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            /*  if (name.includes('монтаж')) {
                  montage_item = item;
              }*/
        });


        _.forEach(data.price, function (item) {
            let name = item.name ? item.name.toLowerCase() : '';
            let ind2 = item.ind2 ? item.ind2.toLowerCase() : '';
            let ind3 = item.ind3 ? item.ind3.toLowerCase() : '';

            let heightPrice = +item.ind4;
            let weightPrice = +item.ind5;


            let priceitem;

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (ind2 === cvetTkan1.toLowerCase() && weightPrice - 100 <= w && w <= weightPrice && heightPrice - 100 < h && h <= heightPrice ) {
                kolvo = 1;
            }

            if (kolvo) {
                //"30,8 - 32,6 - 33,8"
                if (cvetKarniza == 'Белый') {
                    priceitem = parseFloat(ind3.split(' - ')[0]?.trim().replace(',', '.'))
                }
                if (cvetKarniza == 'Коричневый') {
                    priceitem = parseFloat(ind3.split(' - ')[1]?.trim().replace(',', '.'))
                }
                if (cvetKarniza == 'Темно-серый') {
                    priceitem = parseFloat(ind3.split(' - ')[2]?.trim().replace(',', '.'))
                }

                if (system == 'VS2 плиссе арка') {
                    priceitem = priceitem*2
                }

                price['rozn'] = kolvo * priceitem * 1.6 * kursDollara;
                price['opt'] = kolvo * priceitem * kursDollara;
                price['sebest'] = 0;

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+priceitem * 1.6 * 1).toFixed(2),
                        opt: (+priceitem * 1).toFixed(2),
                        sebest: 0,
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

        });

        if (system == 'VS2 плиссе день/ночь') {
            _.forEach(data.price2, function (item) {
                let name = item.name ? item.name.toLowerCase() : '';
                let ind2 = item.ind2 ? item.ind2.toLowerCase() : '';
                let ind3 = item.ind3 ? item.ind3.toLowerCase() : '';

                let heightPrice = +item.ind4;
                let weightPrice = +item.ind5;


                let priceitem;

                let price = {rozn: 0, opt: 0, sebest: 0}
                let kolvo = 0;

                if (ind2 === cvetTkan2.toLowerCase() && weightPrice <= w && w < weightPrice + 100 && heightPrice <= h && h < heightPrice + 100) {
                    kolvo = 1;
                }

                if (kolvo) {
                    //"30,8 - 32,6 - 33,8"
                    if (cvetKarniza == 'Белый') {
                        priceitem = parseFloat(ind3.split(' - ')[0]?.trim().replace(',', '.'))
                    }
                    if (cvetKarniza == 'Коричневый') {
                        priceitem = parseFloat(ind3.split(' - ')[1]?.trim().replace(',', '.'))
                    }
                    if (cvetKarniza == 'Темно-серый') {
                        priceitem = parseFloat(ind3.split(' - ')[2]?.trim().replace(',', '.'))
                    }

//* kursDollara
                    price['rozn'] = kolvo * priceitem * 1.6 * kursDollara;
                    price['opt'] = kolvo * priceitem * kursDollara;
                    price['sebest'] = 0;

                    result.materials[item.name] = {
                        order: +item.poryadok,
                        id: item.idTovar,
                        spis: item.procentSpisania,
                        type: item.edIzmer,
                        oprice: {
                            rozn: (+priceitem * 1.6 * 1).toFixed(2),
                            opt: (+priceitem * 1).toFixed(2),
                            sebest: 0,
                        },
                        price,
                        quantity,
                        count: (+kolvo).toFixed(3)
                    };
                }

            });
        }


        if (title_addons.length > 0) {
            result.title = `${result.title} | ${title_addons.join(', ')}`;
        }

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();

    //выбор картинки системы
    let picture = 'plisse';

    function pictureChange() {
        const selectEl = document.querySelector('.selectSystem');
        const selectedOption = selectEl.options[selectEl.selectedIndex];
        picture = selectedOption.getAttribute('data-extra');
    }

    const tipTkanChange = () => {
        fetchData = fetch();
        change();
    };


    //const changeMaterial = (colors) => cvet = colors?.[0] ?? ''

</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    {@const dop_materials = data.result?.filter((item) =>
        ['ПВХ кронштейны', 'Лесенка', 'Трос', 'Ручка «Гриф» белая', 'Доп. ручка управления'].some(name =>
            item.name?.toLowerCase().trim() === name.toLowerCase()
        )
    )}

    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="parent">
            <div class="imgSystem justify-content-center align-content-center">
                <img style="max-height: 250px;" class="img-fluid" src={`/img/jaluzi/plisse/${picture}.jpg`} alt={system}
                     title={system}/>
            </div>

            <div class="dollar">
                <div class="alert alert-outline-info fade show text-center" role="alert">Курс доллара: $1
                    = {kursDollara}₽
                </div>
            </div>

            <div class="system">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Система</label>
                        <select class="form-control form-select selectSystem" bind:value={system}
                                on:change={pictureChange} on:change={tipTkanChange}>
                            <option value="VS2 плиссе" data-extra="plisse">VS2 плиссе</option>
                            <option value="VS2 плиссе мансарда" data-extra="plisse-mansarda">VS2 плиссе — Мансарда
                            </option>
                            <option value="VS2 плиссе арка" data-extra="plisse-arc">VS2 плиссе — арка</option>
                            <option value="VS2 плиссе день/ночь" data-extra="plisse-dn">VS2 плиссе — день/ночь
                            </option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="tipTkan1">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ткань</label>
                        <select class="form-control form-select" bind:value={tipTkan1} on:change={tipTkanChange}>
                            {#each tkani as item}
                                <option value="{item}">{item}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="cvetTkan1">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет ткани</label>
                        <select class="form-control form-select" bind:value={cvetTkan1} on:change={change}>
                            {#each data.cvetTkani as item}
                                <option value="{item}">{item}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="cvetKarniza">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет карниза</label>
                        <select class="form-control form-select" bind:value={cvetKarniza}>
                            <option value="Белый">Белый</option>
                            <option value="Темно-серый">Темно-серый</option>
                            <option value="Коричневый">Коричневый</option>
                        </select>
                    </div>
                </div>
            </div>


            {#if ($width < 300 || $width > 1200 || $height < 700 || $height > 1800)}
                <div class="info">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase">
                          Изделия не являются гарантийными. По всем вопросам рекомендуем обратиться к менеджеру!
                    </span>
                </div>
            {/if}

            {#if ($height === 1450 || $height > 1450 && $height < 1801)}
                <div class="info2">
                    <span class="badge-success text-white small rounded-2 text-center text-uppercase">
                          Рекомендуем учесть в просчете поддерживающую лесенку!
                    </span>
                </div>
            {/if}


            <div class="width">
                <div class="form-group boxed">
                    <div class="input-wrapper">

                        <label class="form-label">300 ≥ Шир., мм ≥ 1200</label>
                        <input type="number"
                               class="form-control text-center"
                               step="1"
                               min="300"
                               max="1200"
                               bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>

            <div class="height">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">700 ≥ Выс., мм ≥ 2000</label>
                        <input type="number"
                               class="form-control text-center"
                               step="1"
                               min="700"
                               max="2000"
                               bind:value={$height} use:validate_int={$height}>
                    </div>
                </div>
            </div>

            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>

            {#if system === 'VS2 плиссе день/ночь'}
                <div class="tipTkan2">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Ткань</label>
                            <select class="form-control form-select" bind:value={tipTkan2} on:change={tipTkanChange}>
                                {#each tkani as item}
                                    <option value="{item}">{item}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>

                <div class="cvetTkan2">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Цвет ткани</label>
                            <select class="form-control form-select" bind:value={cvetTkan2}>
                                {#each data.cvetTkani2 as item}
                                    <option value="{item}">{item}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            <div class="dop_mat">
                <PodokonnikMaterialList list={dop_materials} bind:components={components}/>
            </div>
        </div>
    </div>
{/await}

<style>
    .parent {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: auto;
        grid-column-gap: 5px;
        grid-row-gap: 0px;
        grid-template-areas:

                    "dollar dollar"
                    "system system"
                    "tipTkan1 cvetTkan1"
                    "cvetKarniza cvetKarniza"
                    "info info"
                    "info2 info2"
                    "width height"
                    "tipTkan2 cvetTkan2"
                    "comment comment"
                    "dop_mat dop_mat"
                    "imgSystem imgSystem"
    }


    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: repeat(3, 1fr);
            grid-template-areas:

                    "imgSystem dollar dollar"
                    "imgSystem system system"
                    "imgSystem tipTkan1 cvetTkan1"
                    "imgSystem cvetKarniza cvetKarniza"
                    "imgSystem info info"
                    "imgSystem info2 info2"
                    "imgSystem width height"
                    "imgSystem tipTkan2 cvetTkan2"
                    "comment comment comment"
                    "dop_mat dop_mat dop_mat"
        }

    }

    .imgSystem {
        grid-area: imgSystem;
    }

    .system {
        grid-area: system;
    }

    .dollar {
        grid-area: dollar;
    }

    .cvetKarniza {
        grid-area: cvetKarniza;
    }

    .height {
        grid-area: height;
    }

    .width {
        grid-area: width;
    }

    .info {
        grid-area: info;
    }

    .info2 {
        grid-area: info2;
    }

    .comment {
        grid-area: comment;
    }

    .dop_mat {
        grid-area: dop_mat;
    }

    .tipTkan2 {
        grid-area: tipTkan2;
    }

    .cvetTkan2 {
        grid-area: cvetTkan2;
    }

    .tipTkan1 {
        grid-area: tipTkan1;
    }

    .cvetTkan1 {
        grid-area: cvetTkan1;
    }


</style>
